import { API } from '@/shared/api/api-config'

import { SPB_CITY_CODE, SPB_CITY_NAME } from '../model/constants'

const getCookieValue = (cookieName: string): string | null => {
	if (typeof document === 'undefined') return null

	const match = document.cookie.match(new RegExp(`(?:^|; )${cookieName}=([^;]+)`))
	return match?.[1] ?? null
}

export const getRegionCookies = (): string => {
	const cookieCityCode = getCookieValue('CITY_CODE')
	const cookieCityName = getCookieValue('CITY_NAME')

	if (cookieCityCode) {
		return cookieCityName ? `CITY_CODE=${cookieCityCode}; CITY_NAME=${cookieCityName};` : `CITY_CODE=${cookieCityCode};`
	}

	if (API.region?.CITY_CODE) {
		return API.region.CITY_NAME
			? `CITY_CODE=${API.region.CITY_CODE}; CITY_NAME=${encodeURI(API.region.CITY_NAME)};`
			: `CITY_CODE=${API.region.CITY_CODE};`
	}

	return `CITY_CODE=${SPB_CITY_CODE}; CITY_NAME=${encodeURI(SPB_CITY_NAME)};`
}
